import { ProcessosAtividadesDTO } from "../../../../viewmodel/CronogramaViewModel";

export function atribuirCoresQuentes(atividades: ProcessosAtividadesDTO[]): ProcessosAtividadesDTO[] {
    let hue = 0; 
    const incrementoHue = 11; 

    return atividades.map((processoAtividade, index) => {
        hue += incrementoHue;

        if (hue >= 70) {
            hue -= 70;
        }

        const corQuente = `hsl(${hue}, 100%, 50%)`;

        return {
            ...processoAtividade,
            cor: corQuente
        };
    });
}
